module.exports = ".lost-password {\n  display: inline-block;\n  margin-top: 1em;\n  color: #ea148c;\n  font-weight: bold;\n  text-decoration: underline;\n  font-size: 1.1em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.less
// module id = 535
// module chunks = 0